import { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import SellerSidebar from "./common/SellerSidebar";
import { organizationDetail } from "../Context/SelectedOrganization";
import axiosClient from "../Services/Axios/axios";
import { BeatLoader } from "react-spinners";
import Swal from "sweetalert2";

function AddUserRole() {
  const { organizationData } = useContext(organizationDetail);
  const [loader, setLoader] = useState(false);
  const location = useLocation();

  const { id } = useParams();
  const navigate = useNavigate();

  const [permissions, setPermissions] = useState([]);
  const [selectedPermissions, setSelectedPermissions] = useState([]);
  const handleToggle = (id) => {
    setPermissions((prev) => {
      const updatedPermissions = prev.map((p) =>
        p.id === id ? { ...p, checked: !p.checked } : p
      );

      // ✅ Sirf IDS store hongi
      const selectedIds = updatedPermissions
        .filter((item) => item.checked)
        .map((item) => Number(item.id));

      setSelectedPermissions(selectedIds);

      return updatedPermissions;
    });
  };

  const hundleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoader(true);
      const response = await axiosClient.post(
        `organizationAccess/${process.env.REACT_APP_API_VERSION}/assign-role`,
        {
          role_id: Number(id),
          organization_id: sessionStorage.getItem("organization_id"),
          module_ids: selectedPermissions,
        }
      );
      if (!response.data.error) {
        setLoader(false);
        Swal.fire({
          icon: "success",
          title: "Success",
          text: response.data.message,
        });
        navigate("/employee-role");
      } else {
        setLoader(false);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: response.data.message,
        });
      }
    } catch (error) {
      console.error(error);
      setLoader(false);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong",
      });
    }
  };
  const getPermisssionList = async () => {
    try {
      setLoader(true);

      //ALL MODULES
      const response = await axiosClient.post(
        `organizationAccess/${process.env.REACT_APP_API_VERSION}/list`
      );

      //ASSIGNED MODULES
      const response1 = await axiosClient.post(
        `organizationAccess/${process.env.REACT_APP_API_VERSION}/role/list`,
        {
          role_id: Number(id),
          organization_id: sessionStorage.getItem("organization_id"),
        }
      );

      const assignedPermissions =
        response1?.data?.data?.map((item) => Number(item.permission_id)) || [];

      // ✅ yahi per condition lagegi
      const formattedPermissions = response?.data?.data?.map((item) => ({
        id: item.id,
        name: item.module_name,
        // agar id assignedPermissions me hai to checked = true
        checked: assignedPermissions.includes(item.id),
      }));

      setPermissions(formattedPermissions);
      setSelectedPermissions(assignedPermissions);
      setLoader(false);
    } catch (error) {
      console.error(error);
      setLoader(false);
    }
  };

  useEffect(() => {
    getPermisssionList();
  }, [organizationData]);
  // Dynamic rows (2 permissions per row)
  const rows = Math.ceil(permissions.length / 2);

  return (
    <div className="all_suport_bg manages_top">
      <section className="ser_v_araeea profiles">
        <div className="container">
          <div className="bradcams">
            <span className="bothss">
              <Link to="/dashboard">Dashboard</Link>{" "}
              <img src="/images/brd_rowwo.png" alt="" /> User Role{" "}
              <img src="/images/brd_rowwo.png" alt="" /> Manage Access Control
              <img src="/images/brd_rowwo.png" alt="" />{" "}
              {location?.state?.data?.role_name}
            </span>
          </div>

          <div className="row">
            <div className="col-lg-3 mb_view_hide">
              <SellerSidebar />
            </div>

            <div className="col-lg-9 order-list">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h4 style={{ fontWeight: "600" }}>
                  Manage Access Control {" > "}{" "}
                  {location?.state?.data?.role_name}
                </h4>
              </div>

              <div className="form_boxx profilss">
                <div className="form_arar mt-0">
                  {loader ? (
                    <div className="loader">
                      <BeatLoader color="#36d7b7" />
                    </div>
                  ) : (
                    <div className="permission-table">
                      <table className="permission-grid">
                        <tbody>
                          {Array.from({ length: rows }).map((_, i) => {
                            const start = i * 2;
                            const row = permissions.slice(start, start + 2);
                            if (row.length === 0) return null;

                            return (
                              <tr
                                key={i}
                                className={i % 2 === 0 ? "even-row" : "odd-row"}
                              >
                                {row.map((item) => (
                                  <td key={item.id}>
                                    <label className="checkbox-label">
                                      <input
                                        type="checkbox"
                                        checked={item.checked}
                                        onChange={() => handleToggle(item.id)}
                                      />
                                      <span>
                                        {item.name.charAt(0).toUpperCase() +
                                          item.name.slice(1)}
                                      </span>
                                    </label>
                                  </td>
                                ))}

                                {/* If only 1 permission in last row, add empty td */}
                                {row.length < 2 && <td></td>}
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  )}

                  <div className="mt-4 text-end">
                    <button className="btn-save" onClick={hundleSubmit}>
                      Save Changes
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default AddUserRole;
